<div class="app" (keydown)="handleKeyPressed($event)">
  <!-- after 300 ms only (Global.requestSpinner): a fast answer made it flicker -->
  @if (globalEnv.requestSpinner()) {
    <div class="loader-spinner">
      <div>
        <i aria-hidden="true" class="icon-spinner"></i>
      </div>
    </div>
  }
  <router-outlet />
  @if (appUpdate.updateReady()) {
    <div class="app-update-banner" role="status" aria-live="polite" data-cy="app-update-banner">
      <i aria-hidden="true" class="fa-solid fa-rotate"></i>
      <span class="app-update-text">
        {{ 'appUpdate.ready' | translate }}
        @if (unsavedChanges.dirtyCount() > 0) {
          <span class="app-update-unsaved">{{ 'appUpdate.unsaved' | translate }}</span>
        }
      </span>
      <button type="button" class="app-update-reload" (click)="appUpdate.reload()">{{ 'appUpdate.reload' | translate }}</button>
      <button type="button" class="app-update-later" (click)="appUpdate.dismiss()">{{ 'appUpdate.later' | translate }}</button>
    </div>
  }
  @if (successMessage) {
    <div class="clearMessageBanner">
      <i aria-hidden="true" class="icon-close" style="cursor: pointer" (click)="closeSuccessMessage()"></i>
      <div class="iu-banner-message">
        <i aria-hidden="true" class="iu-banner-icon fa-lg fas fa-check"></i>
        <span class="iu-banner-message-text"> {{ successMessage.message }} </span>
      </div>
    </div>
  }
</div>

@if (loading()) {
  <iu-status-page-layout class="loading-page" [noMessage]="true" />
}
